// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 认证状态枚举 枚举类
 * 认证状态枚举
 */
export enum EnumCertifyStatus {
  /** 未认证 : 未认证 */
  None = 0,
  /** 认证中 : 认证中 */
  Doing = 1,
  /** 已认证 : 已认证 */
  Certified = 2,
  /** 认证失败 : 认证失败 */
  Faild = 4
}

/**
 * 认证状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumCertifyStatusMD {
  private static items = [
    new EnumItemMD('None', 0, '未认证', '未认证'),
    new EnumItemMD('Doing', 1, '认证中', '认证中'),
    new EnumItemMD('Certified', 2, '已认证', '已认证'),
    new EnumItemMD('Faild', 4, '认证失败', '认证失败')
  ];

  static getItem(enumItem: EnumCertifyStatus) {
    return this.items.find(item => item.name === EnumCertifyStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
